import mitt from 'mitt';
import { MittEventMap } from './PayloadInterfaces';

const emitter = mitt<MittEventMap>();

export { emitter };
